<script setup>
</script>

<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0L14.59 7.41L22 10L14.59 12.59L12 20L9.41 12.59L2 10L9.41 7.41L12 0Z" fill="url(#geminiGradient)"/>
        <defs>
            <linearGradient id="geminiGradient" x1="2" y1="2" x2="22" y2="20" gradientUnits="userSpaceOnUse">
                <stop stop-color="#4285F4"/>
                <stop offset="1" stop-color="#9b72cb"/>
            </linearGradient>
        </defs>
    </svg>
</template>

<style scoped>
</style>